import React from 'react';
import { states } from '@/constants/lifecycle';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import CardItem from '@/components/cards/CardItem';
import urls, { codeUrl } from '@/constants/urls';
import ToggleNoLabel from '@/components/ToggleNoLabel';
import events from '../hooks/events';

const ThemeCardItem = ({ category, theme }) => {
  const show = events.useShowSaveTheme(category, theme);
  const toggleEnabled = events.useUpdateThemeEnabled(category, theme);
  return (
    <CardItem className="aridhia-theme-list-item">
      <NameDescriptionCard
        description={theme.description}
        entity="theme"
        href={codeUrl(urls.THEMES, theme.code)}
        markdown
        name={theme.name}
        loading={theme.updateStatus === states.PENDING}
        onClick={show}
      >
        <ToggleNoLabel
          className="aridhia-theme-list-item-toggle"
          disabled={theme.updateStatus === states.PENDING}
          checked={theme.enabled}
          label={theme.name}
          onClick={() => toggleEnabled(theme)}
        />
      </NameDescriptionCard>
    </CardItem>
  );
};

export default ThemeCardItem;
